import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Columns.module.scss";
import { LinkType, Links } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers } from "../Paragraph/Citation";
export interface Columns {
  columns: {
    _key: string;
    title: string;
    paragraph: string;
    richText?: any[];
    links: Array<LinkType | NavLink>;
  }[];
}
export const Columns: React.FC<Columns> = t0 => {
  const $ = _c(4);
  const {
    columns
  } = t0;
  let t1;
  if ($[0] !== columns) {
    t1 = columns.filter(Boolean).map(_temp);
    $[0] = columns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.grid}>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(column) {
  return <div className={styles.column} key={column._key}><div><h5>{column.title}</h5>{column.richText?.length ? <PortableText value={column.richText} components={customComponentRenderers} /> : <p>{column.paragraph}</p>}</div>{column.links && <Links links={column.links} />}</div>;
}